import dynamic from 'next/dynamic';
import { genEsConfig } from '../es-config';

export const genLineChart = (height = 254) =>
  dynamic(
    () => import('./index-es').then(m => m.default),
    genEsConfig({
      style: { height },
    })
  );

export const LineChart = genLineChart();

export default LineChart;
